import React from "react";
import { Link } from "react-router-dom";
import aiImage from "../../../assets/Demand-Generation1.jpeg";
import strategyImage from "../../../assets/Demand-Generation2.jpeg";

export default function DemandGeneration() {
  return (
    <div className="bg-gradient-to-br from-black via-gray-900 to-black">
      {/* Hero Section */}
      <section className="relative h-[60vh] sm:h-[70vh] md:h-[800px] flex items-center justify-center overflow-hidden">
        <div className="absolute inset-0">
          <img
            src={aiImage}
            alt="Demand Generation & Sales Pipelines"
            className="w-full h-full object-cover sm:object-contain md:object-cover"
          />
          <div className="absolute inset-0 bg-black/60"></div>
        </div>
        <div className="relative z-10 text-center text-white px-4 sm:px-6">
          <h1 className="text-2xl sm:text-3xl md:text-5xl lg:text-6xl font-bold mb-4 leading-tight">
            Demand Generation & Sales Pipelines
          </h1>
          <p className="text-sm sm:text-lg md:text-xl lg:text-2xl max-w-3xl mx-auto leading-relaxed">
            Launch multi-touch digital campaigns, nurture leads through funnels, and optimize conversion
          </p>
        </div>
      </section>

      {/* Content Section */}
      <section className="py-8 sm:py-12 md:py-16 px-4 sm:px-6">
        <div className="max-w-6xl mx-auto">
          <div className="flex flex-col lg:flex-row gap-8 lg:gap-12 items-center">
            {/* Image - Left Side */}
            <div className="flex-1 w-full">
              <img
                src={strategyImage}
                alt="Demand Generation & Sales Pipelines"
                className="w-full h-64 sm:h-80 md:h-96 object-cover rounded-lg shadow-lg"
              />
            </div>

            {/* Content - Right Side */}
            <div className="flex-1 w-full">
              <h2 className="text-xl sm:text-2xl md:text-3xl font-bold mb-4 sm:mb-6 text-white text-center lg:text-left">
                Demand Generation & Sales Pipelines
              </h2>
              <p className="text-sm sm:text-base md:text-lg text-gray-300 leading-relaxed mb-4 sm:mb-6 text-center lg:text-left">
                Launch multi-touch digital campaigns, nurture leads through funnels, and optimize conversion.
              </p>
              <p className="text-sm sm:text-base md:text-lg text-gray-300 leading-relaxed text-center lg:text-left">
                Our demand generation strategies create qualified leads and build robust sales pipelines that drive consistent revenue growth for your business.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Services Offered Section */}
      <section className="py-16 px-4 sm:px-6 bg-gradient-to-br from-gray-900 via-black to-gray-900">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-12 text-white">
            Services Offered
          </h2>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {/* Google Pay Per Click Advertising */}
            <div className="bg-black border border-gray-600 rounded-lg shadow-lg p-6 hover:bg-gray-900 transition-colors duration-300 flex flex-col">
              <h3 className="text-xl font-bold mb-4 text-[#B31F7E]">
                Google Pay Per Click Advertising Services
              </h3>
              <p className="text-gray-300 mb-6 leading-relaxed flex-grow">
                Making sure that your brand is visible when prospects are searching for your products or services is vital for lead generation. As a Premier Google Partner, ALIF has both the experience and knowhow to drive high-quality and qualified traffic to your website.
              </p>
              <Link 
                to="/contact" 
                className="inline-block bg-[#B31F7E] text-white px-4 py-2 rounded-lg hover:bg-[#9a1a6b] transition-colors duration-300 mt-auto text-center"
              >
                Speak to Us
              </Link>
            </div>

            {/* Social Media Advertising */}
            <div className="bg-black border border-gray-600 rounded-lg shadow-lg p-6 hover:bg-gray-900 transition-colors duration-300 flex flex-col">
              <h3 className="text-xl font-bold mb-4 text-[#B31F7E]">
                Social Media Advertising Campaigns
              </h3>
              <p className="text-gray-300 mb-6 leading-relaxed flex-grow">
                From Facebook, Instagram, LinkedIn and Twitter to more modern platforms such as TikTok & Snapchat, ALIF has official partnerships with every major platform to provide advertising and lead generation services for our clients.
              </p>
              <Link 
                to="/contact" 
                className="inline-block bg-[#B31F7E] text-white px-4 py-2 rounded-lg hover:bg-[#9a1a6b] transition-colors duration-300 mt-auto text-center"
              >
                Speak to Us
              </Link>
            </div>

            {/* Email Marketing */}
            <div className="bg-black border border-gray-600 rounded-lg shadow-lg p-6 hover:bg-gray-900 transition-colors duration-300 flex flex-col">
              <h3 className="text-xl font-bold mb-4 text-[#B31F7E]">
                Email Marketing
              </h3>
              <p className="text-gray-300 mb-6 leading-relaxed flex-grow">
                As a Diamond-tiered HubSpot Partner, ALIF implements and manages personalised email marketing campaigns that targets and attracts leads, encouraging them along the buyer journey. From initial outreach through to nurturing, email is an effective lead generation tool if properly implemented.
              </p>
              <Link 
                to="/contact" 
                className="inline-block bg-[#B31F7E] text-white px-4 py-2 rounded-lg hover:bg-[#9a1a6b] transition-colors duration-300 mt-auto text-center"
              >
                Speak to Us
              </Link>
            </div>

            {/* Mobile Application Marketing */}
            <div className="bg-black border border-gray-600 rounded-lg shadow-lg p-6 hover:bg-gray-900 transition-colors duration-300 flex flex-col">
              <h3 className="text-xl font-bold mb-4 text-[#B31F7E]">
                Mobile Application Marketing
              </h3>
              <p className="text-gray-300 mb-6 leading-relaxed flex-grow">
                The success of a mobile application ultimately comes from having volumes of users downloading and using it. We will identify your target audience, create interaction and drive downloads using key messaging and targeted campaigns to facilitate this.
              </p>
              <Link 
                to="/contact" 
                className="inline-block bg-[#B31F7E] text-white px-4 py-2 rounded-lg hover:bg-[#9a1a6b] transition-colors duration-300 mt-auto text-center"
              >
                Speak to Us
              </Link>
            </div>

            {/* Landing Page Development */}
            <div className="bg-black border border-gray-600 rounded-lg shadow-lg p-6 hover:bg-gray-900 transition-colors duration-300 flex flex-col">
              <h3 className="text-xl font-bold mb-4 text-[#B31F7E]">
                Landing Page Development
              </h3>
              <p className="text-gray-300 mb-6 leading-relaxed flex-grow">
                Landing pages play an important role in the lead generation process, especially when a prospect needs deeper education and appreciation for your brand, product or services. ALIF has designed thousands of landing pages and this experience allows us to create high-converting pages quickly and efficiently, supercharging campaign performance.
              </p>
              <Link 
                to="/contact" 
                className="inline-block bg-[#B31F7E] text-white px-4 py-2 rounded-lg hover:bg-[#9a1a6b] transition-colors duration-300 mt-auto text-center"
              >
                Speak to Us
              </Link>
            </div>

            {/* Digital Out of Home */}
            <div className="bg-black border border-gray-600 rounded-lg shadow-lg p-6 hover:bg-gray-900 transition-colors duration-300 flex flex-col">
              <h3 className="text-xl font-bold mb-4 text-[#B31F7E]">
                Digital Out of Home - Outdoor Advertising
              </h3>
              <p className="text-gray-300 mb-6 leading-relaxed flex-grow">
                Utilising signage at public venues and spaces to position your marketing content with specific screens, days, or times. ALIF has access to thousands of screens, helping you pinpoint your content and engage your target audience with precision, boosting brand awareness and lead generation.
              </p>
              <Link 
                to="/contact" 
                className="inline-block bg-[#B31F7E] text-white px-4 py-2 rounded-lg hover:bg-[#9a1a6b] transition-colors duration-300 mt-auto text-center"
              >
                Speak to Us
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}